import { FREE } from 'self-service-api/constants/ProductLevels';
import { BUY_TOUCHLESS, REQUEST_ACCESS, TALK_TO_SALES } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { useAppSelector } from '../reducers';
import { highestProductLevelFromProductInventorySelector } from '../selectors/ProductInventorySelectors';
import { highestProductLevelFromSkuIdsSelector } from '../selectors/ProductsSelectors';
export const useTrackingFlow = ({
  productConfigurations,
  purchaseMotion
}) => {
  const flow = useAppSelector(state => {
    const highestOwnedProductLevel = highestProductLevelFromProductInventorySelector(state);
    const highestSelectedProductLevel = highestProductLevelFromSkuIdsSelector(state, {
      skuIds: productConfigurations.map(({
        skuId
      }) => skuId)
    });
    if (!highestSelectedProductLevel || !highestOwnedProductLevel || highestSelectedProductLevel === FREE // anything-to-free is not a valid flow
    ) {
      return '';
    }
    if ([BUY_TOUCHLESS, REQUEST_ACCESS, TALK_TO_SALES].includes(purchaseMotion)) {
      return `${highestOwnedProductLevel}-to-${highestSelectedProductLevel}`.toLowerCase();
    }
    return '';
  });
  return flow;
};